import './create-issuer-compliance-rule.scss'

import { notification } from 'antd'
import { Formik } from 'formik'
import { Form, FormItem, Input, InputNumber, SubmitButton } from 'formik-antd'
import React from 'react'
import { Column } from 'react-display-flex'

import { httpClient } from '../../../../../util/http-client'
import { issuerCompliancesRulesMessages } from '../messages'
import { createIssuerComplianceRuleValues } from './models'
import { issuerComplianceRuleValidationSchema } from './validators'

interface CreateIssuerComplianceProps {
  groupId: number
  domain: string
  onSuccess?: () => void
}

export const CreateIssuerCompliance = ({ groupId, domain, onSuccess }: CreateIssuerComplianceProps) => {
  const onSubmit = async (formData) => {
    try {
      await httpClient(`/compliances/issuers/groups/${groupId}/rules`, {
        method: 'POST',
        domain,
        data: formData,
      })
      notification.success({
        message: issuerCompliancesRulesMessages.common.success,
        description: issuerCompliancesRulesMessages.create.success,
      })
      onSuccess && onSuccess()
    } catch (error) {
      notification.error({
        message: issuerCompliancesRulesMessages.common.error,
        description: error.error_message || issuerCompliancesRulesMessages.create.error,
      })
    }
  }

  return (
    <Formik
      initialValues={createIssuerComplianceRuleValues}
      validationSchema={issuerComplianceRuleValidationSchema}
      onSubmit={onSubmit}
      enableReinitialize
    >
      <Form name="create-issuer-compliance-rule">
        <FormItem name="ratingType" label="Rating Type" required>
          <Input name="ratingType" />
        </FormItem>
        <FormItem name="rating" label="Rating" required>
          <Input name="rating" />
        </FormItem>
        <FormItem name="maxLimit" label="Max Limit" required>
          <InputNumber name="maxLimit" min={0} />
        </FormItem>
        <Column>
          <SubmitButton htmlType="submit" type="primary">
            Save Rating
          </SubmitButton>
        </Column>
      </Form>
    </Formik>
  )
}
